import React from 'react';
import { SvgIcon } from '@material-ui/core';


const ChevronNavLeft = (props) => {
  return (
    <SvgIcon viewBox="0 0 18 12" {...props}>
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M14.5 5.65C14.859 5.65 15.15 5.35899 15.15 5C15.15 4.64101 14.859 4.35 14.5 4.35V5.65ZM1.04038 4.54038C0.78654 4.79422 0.78654 5.20578 1.04038 5.45962L5.17696 9.59619C5.4308 9.85004 5.84235 9.85004 6.09619 9.59619C6.35003 9.34235 6.35003 8.9308 6.09619 8.67696L2.41924 5L6.09619 1.32304C6.35003 1.0692 6.35003 0.657647 6.09619 0.403806C5.84235 0.149965 5.4308 0.149965 5.17696 0.403806L1.04038 4.54038ZM14.5 4.35L7.31579 4.35V5.65L14.5 5.65V4.35ZM7.31579 4.35L1.5 4.35V5.65L7.31579 5.65V4.35Z" fill="#858383"
      />
    </SvgIcon>
  );
};

export default ChevronNavLeft;
